export default class ViewStudentsController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    students
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.students = students;
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
